import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { buildCrumbs } from './BreadcrumbSchema';

// Visible breadcrumb trail (mirrors the BreadcrumbList schema).
export const Breadcrumbs = ({ light = false, className = '' }) => {
  const { pathname } = useLocation();
  const crumbs = buildCrumbs(pathname);
  if (!crumbs || crumbs.length < 2) return null;
  const tone = light ? 'text-white/70 hover:text-white' : 'text-neutral-500 hover:text-neutral-900';
  return (
    <nav aria-label="Breadcrumb" className={`text-xs tracking-wide ${className}`} data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5">
        {crumbs.map((c, i) => (
          <li key={c.name} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className={`w-3 h-3 ${light ? 'text-white/40' : 'text-neutral-300'}`} />}
            {c.url ? <Link to={c.url.replace(window.location.origin, '')} className={`transition-colors ${tone}`}>{c.name}</Link>
              : <span aria-current="page" className={light ? 'text-white' : 'text-neutral-900'}>{c.name}</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};
